import ConfirmWaitingAbsenceWidget from "./ConfirmWaitingAbsenceWidget.vue";

export { ConfirmWaitingAbsenceWidget };
